import { collection, setDoc, updateDoc, deleteDoc, doc, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "./firebase";
import { roleToFirestore } from "../models/role";
import AuditService, { AUDIT_ACTIONS, AUDIT_MODULES } from "./audit_service";
import { COLLECTIONS } from "../services/collections";

/**
 * RoleService
 * Centraliza as operações de banco de dados para o módulo de Cargos.
 */
const RoleService = {
    /**
     * Busca todos os cargos de um tenant.
     */
    getRoles: async (idTenant) => {
        try {
            const q = query(
                collection(db, "tenants", idTenant, COLLECTIONS.ROLES),
                orderBy("name", "asc")
            );
            const querySnapshot = await getDocs(q);
            const roles = [];
            querySnapshot.forEach((doc) => {
                roles.push({ id: doc.id, ...doc.data() });
            });
            return roles;
        } catch (error) {
            console.error("Erro ao listar cargos:", error);
            throw error;
        }
    },

    /**
     * Salva ou atualiza um cargo.
     */
    save: async (formData, idTenant, authUser, existingRoles = []) => {
        if (!idTenant) throw new Error("ID do Tenant é obrigatório.");

        const roleData = roleToFirestore(formData, idTenant, authUser);

        try {
            if (formData.id) {
                // UPDATE
                const roleRef = doc(db, "tenants", idTenant, COLLECTIONS.ROLES, formData.id);
                const oldRole = existingRoles.find(r => r.id === formData.id) || {};
                await updateDoc(roleRef, roleData);

                // Auditoria
                const changes = AuditService.calculateDiff(oldRole, roleData);
                AuditService.log({
                    idTenant,
                    user: authUser,
                    module: AUDIT_MODULES.ROLES,
                    action: AUDIT_ACTIONS.UPDATE,
                    entityId: formData.id,
                    entityName: roleData.name,
                    description: `Atualizou o cargo "${roleData.name}"`,
                    details: changes
                });

                return { id: formData.id, ...roleData };
            } else {
                const customId = Date.now().toString(36) + Math.random().toString(36).substring(2, 10);
                const newDocRef = doc(db, "tenants", idTenant, COLLECTIONS.ROLES, customId);
                await setDoc(newDocRef, roleData);

                // Auditoria
                AuditService.log({
                    idTenant,
                    user: authUser,
                    module: AUDIT_MODULES.ROLES,
                    action: AUDIT_ACTIONS.CREATE,
                    entityId: newDocRef.id,
                    entityName: roleData.name,
                    description: `Criou o cargo "${roleData.name}"`
                });

                return { id: newDocRef.id, ...roleData };
            }
        } catch (error) {
            console.error("Erro no RoleService.save:", error);
            throw error;
        }
    },

    /**
     * Remove um cargo.
     */
    delete: async (roleId, idTenant, authUser, roleName) => {
        if (!idTenant) throw new Error("ID do Tenant é obrigatório.");

        try {
            await deleteDoc(doc(db, "tenants", idTenant, COLLECTIONS.ROLES, roleId));

            // Auditoria
            AuditService.log({
                idTenant,
                user: authUser,
                module: AUDIT_MODULES.ROLES,
                action: AUDIT_ACTIONS.DELETE,
                entityId: roleId,
                entityName: roleName,
                description: `Excluiu o cargo "${roleName || roleId}"`
            });

            return true;
        } catch (error) {
            console.error("Erro no RoleService.delete:", error);
            throw error;
        }
    }
};

export default RoleService;
